import { createModel } from "@/util/ModelUtil";
import CourseModel from "@/service/model/course/CourseModel";
import LectureModel from "@/service/model/lecture/LectureModel";
import OrganizationModel from "@/service/model/organization/OrganizationModel";

export default class InquiredLectureDataModel {
  constructor(
    public lecture: Lecture = new LectureModel(),
    public lecturer: Lecturer[] = [],
    public course: Course = new CourseModel(),
    public organization: Organization = new OrganizationModel()
  ) {}

  public static create(
    lecture?: InquiredLectureData
  ): InquiredLectureDataModel {
    return createModel<InquiredLectureDataModel>(
      InquiredLectureDataModel,
      lecture
    );
  }
}
